import IconRelation from "../../components/icons/IconRelation";
import IconChangeStage from "../../components/icons/IconChangeStage";
import IconKeys from "../../components/icons/IconKeys";
import IconButton from "../../components/icons/IconButton";
import IconFinish from "../../components/icons/IconFinish";

function connectorBorderColor(connector) {
    if (connector.isRight && connector.isRight.id == 1) return "#30e846";
    if (connector.isRight && connector.isRight.id == 2) return "#f47126";
    return "#7f7f7f";
}

function incomingDotColor(connector) {
    if (connector.isRight && connector.isRight.id == 1) return "#30e846";
    if (connector.isRight && connector.isRight.id == 2) return "#f47126";
    return "#919191";
}

// Renders the incoming-connection markers and the outgoing answer badges for
// a question node, including the hover hints and the delete-on-click menu.
export default function ConnectorList({ item, form }) {
    const { hintConnector, showHint, clearHint, connectorFunctionsToShowId, showConnectorFunctions, deleteConnectorHandler } = form;

    return (
        <>
            <div className="question-answers-wraper-come">
                {item && item.answerConnectorsNext
                    ? item.answerConnectorsNext.map((connector) => (
                          <div
                              key={connector.id}
                              style={{ background: incomingDotColor(connector) }}
                              className="question-answer-connector-come"
                          />
                      ))
                    : ""}
            </div>

            <div className="question-answers-wraper">
                {item && item.answerConnectorsFrom && item.answerConnectorsFrom.length > 0 ? (
                    item.answerConnectorsFrom.map((connector) => (
                        <div
                            key={connector.id}
                            onClick={(e) => showConnectorFunctions(e, connector.id)}
                            style={{ borderRight: `3px solid ${connectorBorderColor(connector)}` }}
                            className="question-answer-connector"
                        >
                            {connector.estimationGroup ? (
                                <div
                                    className="connector-icon"
                                    onMouseOver={() => showHint(connector.id, "estimationGroup")}
                                    onMouseLeave={clearHint}
                                >
                                    {hintConnector && hintConnector.connectorId === connector.id && hintConnector.hintName === "estimationGroup" ? (
                                        <div className="connector-hint">
                                            <p>До цієї опції прикріплерно групу оцінки:</p>
                                            <p className="txt-c">{connector.estimationGroup.name}</p>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <IconRelation fillColor="icon-orange" style={{ height: 22, width: 22, margin: 0 }} />
                                </div>
                            ) : (
                                ""
                            )}

                            {connector.stage ? (
                                <div
                                    className="connector-icon"
                                    onMouseOver={() => showHint(connector.id, "stage")}
                                    onMouseLeave={clearHint}
                                >
                                    {hintConnector && hintConnector.connectorId === connector.id && hintConnector.hintName === "stage" ? (
                                        <div className="connector-hint">
                                            <p>До цієї опції прикріплерно етап:</p>
                                            <p className="txt-c">{connector.stage.name}</p>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <IconChangeStage fillColor="icon-yellow" style={{ height: 22, width: 22, margin: 0 }} />
                                </div>
                            ) : (
                                ""
                            )}

                            <div>
                                {connector.clasification && connector.clasification.id == 1 ? (
                                    <IconKeys fillColor="icon-teel" style={{ height: 22, width: 22, margin: 0 }} />
                                ) : (
                                    <IconButton fillColor="icon-teel" style={{ height: 22, width: 22, margin: 0 }} />
                                )}
                            </div>

                            <p>{connector.text}</p>

                            {connectorFunctionsToShowId == connector.id ? (
                                <div className="connector-functions-container">
                                    <div
                                        className="icon icon-delete"
                                        onClick={(e) => deleteConnectorHandler(e, connector.id)}
                                        style={{ minHeight: 20, minWidth: 20, maxHeight: 20, maxWidth: 20 }}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    ))
                ) : (
                    <IconFinish fillColor="icon-blue" style={{ height: 70, width: 70, margin: 10 }} />
                )}
            </div>
        </>
    );
}
